import { render, staticRenderFns } from "./Modulistica.vue?vue&type=template&id=755c5e41&"
import script from "./Modulistica.vue?vue&type=script&lang=js&"
export * from "./Modulistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports